export default __webpack_public_path__ + "static/media/background1-start-journey.468bd707.png";